import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import "./Style.css";
import axiosInstance from "../../../../hooks/axiosInstance";

export default function EditCheckIn({ showEdit, closeModal, refreshPage, CheckInData }) {
    const [validationError, setValidationError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [warehouse, setWarehouse] = useState([]);
    const [products, setProducts] = useState([]);
    const [subCategories, setSubCategories] = useState([]);

    const [formData, setFormData] = useState({
        category_id: "",
        sub_category_id: "",
        product_id:"",
        ware_house_id: "",
        production_date: "",
        quantity: "",
        batch_number: "",
    });

    // Prefill form fields with existing data from CheckInData
    useEffect(() => {
        if (CheckInData) {
            setFormData({
                id: CheckInData.id || 1,
                category_id: CheckInData.category_id || "",
                sub_category_id: CheckInData.sub_category_id || "",
                product_id: CheckInData.product_id || "",
                ware_house_id: CheckInData.ware_house_id || "",
                production_date: CheckInData.production_date || "",
                quantity: CheckInData.quantity || "",
                batch_number: CheckInData.batch_number || "",
            });
        }
    }, [CheckInData]);

    const resetForm = () => {
        setFormData({
            category_id: "",
            sub_category_id: "",
            ware_house_id: "",
            production_date: "",
            quantity: "",
            batch_number: "",

        });
        setValidationError({});
    };

    // Fetch categories, units of measure, and groups
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get("/user/category/fetch");
                setCategories(response.data.data.category.data);

                const house = await axiosInstance.get("/user/warehouses/get_warehouse");
                setWarehouse(house.data.data.warehouse);
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };

        fetchData();
    }, []);

    // Fetch products when subcategory changes
    useEffect(() => {
        const fetchProduct = async () => {
            if (formData.sub_category_id) {
                try {
                    const response = await axiosInstance.get(
                        `/user/order/get_product_by_subcategory?sub_category_id=${formData.sub_category_id}`
                    );
                    setProducts(response.data.data.products);
                } catch (error) {
                    console.error("Error fetching products", error);
                }
            }
        };
        fetchProduct();
    }, [formData.sub_category_id]);

    // Fetch subcategories when category changes
    useEffect(() => {
        const fetchSubCategories = async () => {
            if (formData.category_id) {
                try {
                    const response = await axiosInstance.get(
                        `/user/category/getSubCategory?category_id=${formData.category_id}`
                    );
                    setSubCategories(response.data.data.subCategories);
                } catch (error) {
                    console.error("Error fetching subcategories", error);
                }
            }
        };

        fetchSubCategories();
    }, [formData.category_id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await axiosInstance.post("/user/check_in/update", {
                id: CheckInData.id,
                category_id: formData.category_id,
                sub_category_id: formData.sub_category_id,
                product_id: formData.product_id,
                ware_house_id: formData.ware_house_id,
                production_date: formData.production_date,
                quantity: formData.quantity,
                batch_number: formData.batch_number,
            });
            refreshPage();
            handleClose();
        } catch (error) {
            console.error("Error submitting form", error);
        }
        setIsLoading(false);
    };

    const handleChange = (e) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [e.target.name]: e.target.value,
        }));
    };

    const handleClose = () => {
        closeModal();
    };

    return (
        <div className="CreateCSP">
            <Modal show={showEdit} onHide={handleClose} dialogClassName="modal-md">
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Check-In</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3" controlId="formCategory">
                            <div>
                                <h6>Category</h6>
                            </div>
                            <Form.Select
                                aria-label="Select Category"
                                name="category_id"
                                value={formData.category_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Category</option>
                                {categories.map((cat) => (
                                    <option key={cat.id} value={cat.id}>
                                        {cat.name}
                                    </option>
                                ))}
                            </Form.Select>
                            {validationError.category_id && (
                                <small className="text-danger my-1">
                                    {validationError.category_id[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formSubCategory">
                            <div>
                                <h6>Sub-category</h6>
                            </div>
                            <Form.Select
                                aria-label="Select Sub-category"
                                name="sub_category_id"
                                value={formData.sub_category_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Sub-category</option>
                                {subCategories.map((subCat) => (
                                    <option key={subCat.id} value={subCat.id}>
                                        {subCat.name}
                                    </option>
                                ))}
                            </Form.Select>
                            {validationError.sub_category_id && (
                                <small className="text-danger my-1">
                                    {validationError.sub_category_id[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formSubCategory">
                            <div>
                                <h6>Product</h6>
                            </div>
                            <Form.Select
                                aria-label="Select Sub-category"
                                name="product_id"
                                value={formData.product_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="">--select product--</option>
                                {products.map((prod) => (
                                    <option key={prod.id} value={prod.id}>
                                        {prod.product_name}
                                    </option>
                                ))}
                            </Form.Select>
                            {validationError.product_id && (
                                <small className="text-danger my-1">
                                    {validationError.product_id[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group controlId="warehouseInput">
                            <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"> Warehouse</span>
                                </div>
                                <select
                                    className="form-control custom-select"
                                    name="ware_house_id"
                                    value={formData.ware_house_id}
                                    onChange={handleChange}
                                >
                                    <option value="">-- Select Warehouse Name --</option>
                                    {warehouse.map((ware) => (
                                        <option key={ware.id} value={ware.id}>
                                            {ware.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {validationError.ware_house_id && (
                                <small className="text-danger my-1">
                                    {validationError.ware_house_id[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <div>
                                <h6>Production Date</h6>
                            </div>
                            <Form.Control
                                type="date"
                                placeholder="Enter..."
                                name="production_date"
                                value={formData.production_date}
                                onChange={handleChange}
                            />
                            {validationError.production_date && (
                                <small className="text-danger my-1">
                                    {validationError.production_date[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formQuantity">
                            <div><h6>Quantity</h6></div>
                            <Form.Control
                                type="number"
                                name="quantity"
                                value={formData.quantity}
                                onChange={handleChange}
                                required
                            />
                            {validationError.quantity && (
                                <small className="text-danger my-1">{validationError.quantity[0]}</small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <div>
                                <h6>Batch Number</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="batch_number"
                                value={formData.batch_number}
                                onChange={handleChange}
                            />
                            {validationError.batch_number && (
                                <small className="text-danger my-1">
                                    {validationError.batch_number[0]}
                                </small>
                            )}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn-md mb-3 mt-3"
                            variant="secondary"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="btn-md mb-3 mt-3"
                            variant="primary"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? "Updating..." : "Update"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}